import { SelfServiceAPI } from 'types';
import { sentenceCase } from 'lib/humanize/humanize';
import { FeesDisclaimer } from 'components/Disclaimers';
import LineItem from 'components/LineItem';

interface PayableAtPropertyLineItemProps {
  formattedCheckIn: string;
  description: string;
  charge: SelfServiceAPI.Total;
}

const PayableAtPropertyLineItem = ({ formattedCheckIn, description, charge }: PayableAtPropertyLineItemProps) => (
  <LineItem title={sentenceCase(description)} totals={[charge]}>
    Charged in local currency. Payable at property at check-in on {formattedCheckIn}
    <FeesDisclaimer.Link />
  </LineItem>
);

export default PayableAtPropertyLineItem;
